// GoogleAdseneCalculator.js
import { useEffect, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";

const TITLE = "Kalkulator Google Adsense - Hitung Keuntungan Google Adsense";
const DESCRIPTION =
  "Dengan kalkulator Google Adsense ini, kami bertujuan membantu Anda menghitung pendapatan yang dapat Anda peroleh dari program Google Adsense.";
const KEYWORDS =
  "kalkulator Google Adsense, hitung keuntungan Google Adsense, pengaturan pendapatan Google Adsense, program Google Adsense, hitung pendapatan harian Google Adsense, untung dari iklan online";
const OG_URL = "https://do-calculate.com/calculator/id/google-adsense/";

const conversionMap = {
  day: 1,
  week: 7,
  month: 30.436875,
  year: 365.2425,
};

const inputStyle = {
  width: "200px",
  marginLeft: "10px",
  backgroundColor: "#f9f9f9",
  border: "1px solid rgba(0, 0, 0, 0.23)",
  borderRadius: "4px",
  padding: "8.5px 14px",
  fontSize: "14px",
  outlineColor: "#2e7d32",
};

const selectStyle = {
  ...inputStyle,
  width: "auto",
  padding: "7.5px 10px",
  cursor: "pointer",
};

const labelStyle = {
  display: "block",
  fontSize: "12px",
  color: "#666",
  marginBottom: "4px",
};

const GoogleAdsenseCalculator = () => {
  // ── Inputs ──────────────────────────────────────────────────────────────
  const [pageViews, setPageViews] = useState("");
  const [pageViewsPeriod, setPageViewsPeriod] = useState("day");
  const [adsPerPage, setAdsPerPage] = useState("");
  const [CTR, setCTR] = useState("");
  const [CPC, setCPC] = useState("");

  // ── Output period selectors ─────────────────────────────────────────────
  const [conversionImpressions, setConversionImpressions] = useState("day");
  const [conversionClicks, setConversionClicks] = useState("day");
  const [conversionRevenue, setConversionRevenue] = useState("day");

  // ── Computed results ────────────────────────────────────────────────────
  const [adImpressions, setAdImpressions] = useState("");
  const [numberOfClicks, setNumberOfClicks] = useState("");
  const [googleAdseneRevenue, setGoogleAdseneRevenue] = useState("");

  // ── Single unified recalculation effect ────────────────────────────────
  useEffect(() => {
    const views     = parseFloat(pageViews);
    const ads       = parseFloat(adsPerPage);
    const ctr       = parseFloat(CTR) / 100;   // % → ratio
    const cpc       = parseFloat(CPC);
    const inFactor  = conversionMap[pageViewsPeriod];

    if (isNaN(views) || views <= 0 || !inFactor) {
      setAdImpressions("");
      setNumberOfClicks("");
      setGoogleAdseneRevenue("");
      return;
    }

    const dailyViews = views / inFactor; // normalise to per-day

    if (isNaN(ads) || ads <= 0) {
      setAdImpressions("");
      setNumberOfClicks("");
      setGoogleAdseneRevenue("");
      return;
    }

    const dailyImpressions = dailyViews * ads;
    setAdImpressions(
      Math.round(dailyImpressions * conversionMap[conversionImpressions])
    );

    if (isNaN(ctr)) {
      setNumberOfClicks("");
      setGoogleAdseneRevenue("");
      return;
    }

    const dailyClicks = dailyImpressions * ctr;
    setNumberOfClicks(
      Math.round(dailyClicks * conversionMap[conversionClicks])
    );

    if (isNaN(cpc)) {
      setGoogleAdseneRevenue("");
      return;
    }

    const dailyRevenue = dailyClicks * cpc;
    setGoogleAdseneRevenue(
      (dailyRevenue * conversionMap[conversionRevenue]).toFixed(2)
    );
  }, [
    pageViews,
    pageViewsPeriod,
    adsPerPage,
    CTR,
    CPC,
    conversionImpressions,
    conversionClicks,
    conversionRevenue,
  ]);

  // ── Input handlers ──────────────────────────────────────────────────────
  const handlePageViewsChange = (e) => {
    if (/^\d*$/.test(e.target.value)) setPageViews(e.target.value);
  };

  const handleAdsPerPageChange = (e) => {
    if (/^\d*$/.test(e.target.value)) setAdsPerPage(e.target.value);
  };

  const handleCTRChange = (e) => {
    if (/^\d*\.?\d*$/.test(e.target.value)) setCTR(e.target.value);
  };

  const handleCPCChange = (e) => {
    if (/^\d*\.?\d*$/.test(e.target.value)) setCPC(e.target.value);
  };

  // ── Reset ────────────────────────────────────────────────────────────────
  const handleReset = () => {
    setPageViews("");
    setPageViewsPeriod("day");
    setAdsPerPage("");
    setCTR("");
    setCPC("");
    setConversionImpressions("day");
    setConversionClicks("day");
    setConversionRevenue("day");
    setAdImpressions("");
    setNumberOfClicks("");
    setGoogleAdseneRevenue("");
  };

  const PeriodSelect = ({ value, onChange }) => (
    <select value={value} onChange={onChange} style={selectStyle}>
      <option value="day">Per hari</option>
      <option value="week">Per minggu</option>
      <option value="month">Per bulan</option>
      <option value="year">Per tahun</option>
    </select>
  );

  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>

          <div className="row">
            <div>
              <h2 style={{ fontSize: "18px" }}>Apa itu Google AdSense :</h2>
              <p>
                Adalah program yang dikembangkan oleh Google yang memungkinkan penerbit situs web untuk memonetisasi konten mereka dengan menampilkan iklan bertarget di situs web mereka. <br /> Pengiklan menawar ruang iklan, dan Google mencocokkan iklan yang relevan dengan konten situs web.
              </p>
              <p>
                Bagaimana cara kerja Google AdSense ? <br /> Ketika pengunjung mengklik salah satu iklan, penerbit situs web menerima sebagian dari pendapatan yang dihasilkan pengiklan. AdSense adalah salah satu program iklan paling populer di internet, dan dapat menjadi sumber pendapatan penting bagi pemilik situs web yang memiliki lalu lintas besar. Selain itu, bergabung dengan Google AdSense gratis dan mudah diatur dan dikelola.
              </p>
              <p>
                Bagaimana cara menghitung pendapatan Google AdSense : <br />
                Menghitung jumlah tayangan iklan: Untuk menghitung jumlah tayangan iklan, kita mengalikan jumlah tampilan halaman dengan jumlah iklan di setiap halaman.
                <br />
                Jumlah klik: Untuk menghitung jumlah klik, kita mengalikan tayangan iklan dengan rasio klik-tayang (CTR)
                <br />
                Pendapatan Google AdSense: Untuk menghitung pendapatan Google AdSense, kita mengalikan jumlah tampilan halaman dengan jumlah iklan per halaman dengan rasio klik-tayang dengan biaya per klik yaitu: <br />
                Pendapatan Google AdSense = tampilan halaman × iklan per halaman × CTR × CPC
              </p>
              <p>Atau pendapatan Google AdSense dihitung melalui kalkulator berikut :</p>
              <hr />
            </div>
          </div>

          <MobileUnderCalAds />

          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <h3
                className="p-3 mb-3 bg-success text-white"
                style={{ fontSize: "16px", fontWeight: "bold", borderRadius: "4px" }}
              >
                Hitung Keuntungan Google Adsense - Google Adsense Calculator
              </h3>

              {/* ── Page Views ── */}
              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Jumlah Tampilan Halaman</label>
                  <input
                    style={inputStyle}
                    type="text"
                    inputMode="numeric"
                    value={pageViews}
                    onChange={handlePageViewsChange}
                    placeholder="Contoh: 100000"
                  />
                </div>
                <PeriodSelect
                  value={pageViewsPeriod}
                  onChange={(e) => setPageViewsPeriod(e.target.value)}
                />
              </div>

              {/* ── Ads Per Page ── */}
              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Jumlah Iklan per Halaman</label>
                  <input
                    style={inputStyle}
                    type="text"
                    inputMode="numeric"
                    value={adsPerPage}
                    onChange={handleAdsPerPageChange}
                    placeholder="Contoh: 3"
                  />
                </div>
                <div style={{ padding: "8.5px 12px", fontSize: "14px", color: "#666" }}>
                  Per Halaman
                </div>
              </div>

              {/* ── Ad Impressions (result) ── */}
              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Tayangan Iklan</label>
                  <input
                    style={inputStyle}
                    type="text"
                    value={adImpressions}
                    readOnly
                    placeholder="—"
                  />
                </div>
                <PeriodSelect
                  value={conversionImpressions}
                  onChange={(e) => setConversionImpressions(e.target.value)}
                />
              </div>

              <hr />

              {/* ── CTR ── */}
              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Rasio Klik-Tayang (CTR)</label>
                  <input
                    style={inputStyle}
                    type="text"
                    inputMode="decimal"
                    value={CTR}
                    onChange={handleCTRChange}
                    placeholder="Contoh: 2.5"
                  />
                </div>
                <div style={{ fontSize: "20px", paddingBottom: "5px" }}>%</div>
              </div>

              {/* ── Clicks (result) ── */}
              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Jumlah Klik</label>
                  <input
                    style={inputStyle}
                    type="text"
                    value={numberOfClicks}
                    readOnly
                    placeholder="—"
                  />
                </div>
                <PeriodSelect
                  value={conversionClicks}
                  onChange={(e) => setConversionClicks(e.target.value)}
                />
              </div>

              <hr />

              {/* ── CPC ── */}
              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Biaya Per Klik (CPC)</label>
                  <input
                    style={inputStyle}
                    type="text"
                    inputMode="decimal"
                    value={CPC}
                    onChange={handleCPCChange}
                    placeholder="Contoh: 0.50"
                  />
                </div>
                <div style={{ fontSize: "20px", paddingBottom: "5px" }}>$</div>
              </div>

              {/* ── Revenue (result) ── */}
              <div className="mb-3 d-flex" style={{ alignItems: "flex-end" }}>
                <div>
                  <label style={labelStyle}>Pendapatan Google Adsense</label>
                  <input
                    style={inputStyle}
                    type="text"
                    value={googleAdseneRevenue !== "" ? `${googleAdseneRevenue} $` : ""}
                    readOnly
                    placeholder="—"
                  />
                </div>
                <PeriodSelect
                  value={conversionRevenue}
                  onChange={(e) => setConversionRevenue(e.target.value)}
                />
              </div>

              {/* ── Reset ── */}
              <div className="mt-4">
                <button
                  style={{
                    backgroundColor: "#6c757d",
                    color: "white",
                    border: "none",
                    padding: "10px 25px",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "15px",
                  }}
                  onClick={handleReset}
                >
                  Hapus Hasil
                </button>
              </div>
            </div>
          </div>

          <hr />
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>

        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={500} />
          <br />
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════════════════
          SEO INFORMATIONAL CONTENT
      ════════════════════════════════════════════════════════════════ */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">

            {/* ── Section 1: What is this calculator ── */}
            <div className="info-section">
              <div className="info-section-header">
                <strong>Apa itu Kalkulator Google Adsense?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Kalkulator Google Adsense</strong> adalah alat elektronik gratis yang membantu Anda memperkirakan keuntungan yang dapat Anda peroleh dari program Google AdSense berdasarkan statistik situs Anda yang sebenarnya. Kalkulator ini memungkinkan Anda:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Menghitung tayangan iklan:</strong> Dengan mengalikan jumlah tampilan halaman dengan jumlah iklan per halaman
                  </li>
                  <li>
                    <strong>Memperkirakan jumlah klik:</strong> Menggunakan rasio klik-tayang (CTR) yang dicapai situs Anda
                  </li>
                  <li>
                    <strong>Menghitung pendapatan yang diharapkan:</strong> Dengan mengalikan jumlah klik dengan rata-rata biaya per klik (CPC)
                  </li>
                  <li>
                    <strong>Mengonversi periode waktu:</strong> Menampilkan hasil harian, mingguan, bulanan, atau tahunan
                  </li>
                  <li>
                    <strong>Merencanakan pendapatan:</strong> Membuat proyeksi realistis pendapatan Anda dari iklan
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Cara Menggunakan Kalkulator AdSense:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>Masukkan jumlah tampilan halaman harian atau bulanan situs Anda</li>
                  <li>Masukkan rata-rata jumlah iklan per halaman (maksimal 3)</li>
                  <li>
                    Masukkan rasio klik-tayang (CTR) — rata-rata antara 1% dan 5%
                  </li>
                  <li>
                    Masukkan rata-rata biaya per klik (CPC) dalam dolar — bervariasi tergantung niche dan negara
                  </li>
                  <li>Hasil akan muncul secara otomatis dengan opsi mengubah periode waktu</li>
                </ol>
                <div className="alert alert-info mt-3" style={{ lineHeight: "1.8" }}>
                  <strong>💡 Catatan:</strong> Kalkulator ini memberikan perkiraan indikatif. Keuntungan aktual dipengaruhi oleh banyak faktor seperti topik situs, negara pengunjung, dan musim iklan.
                </div>
              </div>
            </div>

            {/* ── Section 2: How AdSense works ── */}
            <div className="info-section">
              <div className="info-section-header">
                <strong>Bagaimana Cara Kerja Google AdSense dan Bagaimana Meningkatkan Keuntungan Anda?</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Google AdSense bekerja dengan model lelang instan — setiap kali pengunjung membuka halaman Anda, pengiklan bersaing untuk ruang iklan dan iklan pemenang ditampilkan secara otomatis. Berikut faktor-faktor utama yang mempengaruhi keuntungan Anda:
                </p>
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  1. Memilih Niche dengan CPC Tinggi:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Niche dengan keuntungan tertinggi:</strong> Asuransi, hukum, keuangan, kesehatan, properti
                  </li>
                  <li>
                    <strong>Niche menengah:</strong> Teknologi, pendidikan, perjalanan, belanja online
                  </li>
                  <li>
                    <strong>Niche rendah:</strong> Hiburan, berita umum, konten hiburan
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                  2. Mengoptimalkan Posisi Iklan:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Iklan di atas lipatan:</strong> Bagian yang terlihat tanpa menggulir mencapai rasio klik yang jauh lebih tinggi
                  </li>
                  <li>
                    <strong>Di dalam konten:</strong> Iklan yang tertanam dalam teks memberikan kinerja yang sangat baik
                  </li>
                  <li>
                    <strong>Akhir artikel:</strong> Pembaca yang tertarik menyelesaikan artikel dan lebih cenderung mengklik
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                  3. Meningkatkan Kualitas Lalu Lintas:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Pengunjung dari negara maju:</strong> Amerika Serikat, Kanada, Inggris Raya menghasilkan CPC lebih tinggi
                  </li>
                  <li>
                    <strong>Lalu lintas pencarian organik:</strong> Pengunjung yang datang dari Google lebih banyak berinteraksi dengan iklan
                  </li>
                  <li>
                    <strong>Konten bertarget:</strong> Pengunjung dengan niat beli menghasilkan pendapatan lebih tinggi
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                  4. Meningkatkan Pengalaman Pengguna:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>Kecepatan situs:</strong> Situs cepat meningkatkan rasio pentalan dan meningkatkan tampilan halaman
                  </li>
                  <li>
                    <strong>Kompatibilitas dengan ponsel:</strong> Lebih dari 60% iklan ditampilkan di perangkat seluler
                  </li>
                  <li>
                    <strong>Konten menarik:</strong> Semakin lama pengunjung tinggal, semakin besar peluang iklan muncul dan diklik
                  </li>
                </ul>
              </div>
            </div>

            {/* ── Section 3: CTR / CPC / RPM explained ── */}
            <div className="info-section">
              <div className="info-section-header">
                <strong>Penjelasan Istilah: CTR, CPC, RPM, dan CPM</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Untuk menggunakan Kalkulator AdSense dengan benar dan memahami laporan Anda, Anda perlu mengetahui istilah-istilah dasar ini:
                </p>
                <table className="table bmi-table" style={{ marginTop: "1rem" }}>
                  <thead>
                    <tr>
                      <th className="bmi-header" style={{ textAlign: "center" }}>Istilah</th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>Arti</th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>Rata-rata Umum</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>CTR</strong> — Rasio Klik-Tayang</td>
                      <td style={{ textAlign: "center" }}>Klik ÷ Tayangan × 100</td>
                      <td style={{ textAlign: "center" }}>1% — 3%</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>CPC</strong> — Biaya Per Klik</td>
                      <td style={{ textAlign: "center" }}>Berapa yang Anda hasilkan per klik</td>
                      <td style={{ textAlign: "center" }}>$0.10 — $2.00</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>RPM</strong> — Pendapatan per 1000 Tayangan</td>
                      <td style={{ textAlign: "center" }}>Pendapatan ÷ Tayangan × 1000</td>
                      <td style={{ textAlign: "center" }}>$1 — $10</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>CPM</strong> — Biaya per 1000 Tayangan</td>
                      <td style={{ textAlign: "center" }}>Yang dibayar pengiklan per 1000 tayangan</td>
                      <td style={{ textAlign: "center" }}>$0.50 — $5</td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center" }}><strong>Page RPM</strong></td>
                      <td style={{ textAlign: "center" }}>Pendapatan ÷ Tampilan Halaman × 1000</td>
                      <td style={{ textAlign: "center" }}>$1 — $15</td>
                    </tr>
                  </tbody>
                </table>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  Berapa Rata-rata CTR yang Baik untuk AdSense?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Rata-rata CTR untuk sebagian besar situs berkisar antara <strong>1% dan 3%</strong>. Rasio di atas 3% dianggap sangat baik, tetapi perhatikan: CTR yang sangat tinggi (lebih dari 10%) dapat menimbulkan kekhawatiran Google tentang klik tidak sah.
                </p>
                <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                  <strong>✓ Tips:</strong> Anda dapat menggunakan kalkulator ini secara terbalik — masukkan target pendapatan dan coba nilai CTR dan CPC yang berbeda untuk mengetahui apa yang perlu Anda capai untuk mencapai target Anda.
                </div>
              </div>
            </div>

            {/* ── Section 4: Practical examples ── */}
            <div className="info-section">
              <div className="info-section-header">
                <strong>Contoh Praktis Menghitung Keuntungan AdSense</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  Contoh 1: Situs Blog Menengah
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Data:</strong> 5.000 tampilan per hari, 3 iklan per halaman, CTR = 2%, CPC = $0.30
                </p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Perhitungan:</strong><br />
                  Tayangan iklan = 5.000 × 3 = 15.000 tayangan/hari<br />
                  Jumlah klik = 15.000 × 2% = 300 klik/hari<br />
                  Pendapatan harian = 300 × $0.30 = <strong>$90/hari</strong><br />
                  Pendapatan bulanan ≈ <strong>$2.700/bulan</strong>
                </div>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                  Contoh 2: Situs Teknologi Spesialis
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Data:</strong> 2.000 tampilan per hari, 3 iklan, CTR = 1.5%, CPC = $1.50
                </p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Perhitungan:</strong><br />
                  Tayangan iklan = 2.000 × 3 = 6.000 tayangan/hari<br />
                  Jumlah klik = 6.000 × 1.5% = 90 klik/hari<br />
                  Pendapatan harian = 90 × $1.50 = <strong>$135/hari</strong><br />
                  Pendapatan bulanan ≈ <strong>$4.050/bulan</strong>
                </div>
                <p style={{ lineHeight: "1.8" }}>
                  Perhatikan bagaimana situs teknologi menghasilkan pendapatan lebih tinggi meskipun jumlah kunjungan lebih sedikit — karena tingginya nilai CPC di bidang teknologi.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "10px" }}>
                  Contoh 3: Situs Berita Besar
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Data:</strong> 100.000 tampilan per hari, 3 iklan, CTR = 1%, CPC = $0.15
                </p>
                <div className="alert alert-info" style={{ fontSize: "14px", lineHeight: "1.8" }}>
                  <strong>Perhitungan:</strong><br />
                  Tayangan iklan = 100.000 × 3 = 300.000 tayangan/hari<br />
                  Jumlah klik = 300.000 × 1% = 3.000 klik/hari<br />
                  Pendapatan harian = 3.000 × $0.15 = <strong>$450/hari</strong><br />
                  Pendapatan bulanan ≈ <strong>$13.500/bulan</strong>
                </div>
              </div>
            </div>

            {/* ── Section 5: FAQ ── */}
            <div className="info-section">
              <div className="info-section-header">
                <strong>Pertanyaan Umum tentang Google AdSense</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "8px" }}>
                  Berapa bayaran AdSense per 1000 tampilan?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Rata-rata pendapatan per 1000 tampilan (Page RPM) berkisar antara <strong>$1 dan $10</strong> di sebagian besar niche, dan dapat mencapai $50 atau lebih di niche seperti asuransi dan hukum. Angka bervariasi secara signifikan tergantung negara pengunjung, niche situs, dan kualitas konten.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>
                  Berapa jumlah kunjungan minimum untuk diterima di AdSense?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Tidak ada batas minimum resmi untuk jumlah kunjungan, tetapi disarankan untuk memiliki situs dengan <strong>konten asli dan cukup</strong> (tidak kurang dari 20-30 artikel) sebelum mendaftar. Fokus harus pada kualitas konten dan kepatuhan terhadap kebijakan Google.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>
                  Apakah bisa menggunakan AdSense dengan situs berbahasa Arab?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Ya, <strong>Google AdSense mendukung situs berbahasa Arab sepenuhnya</strong>. Arab Saudi, Uni Emirat Arab, dan Mesir adalah pasar Arab dengan pengeluaran iklan tertinggi, yang berarti CPC yang wajar berkisar antara $0.05 hingga $0.50 di sebagian besar niche.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>
                  Kapan keuntungan AdSense sampai ke rekening bank?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  Google AdSense mengeluarkan pembayaran bulanan ketika saldo melebihi batas <strong>$100</strong>. Keuntungan dikonfirmasi pada akhir setiap bulan, dan ditransfer antara tanggal 21 dan 26 bulan berikutnya.
                </p>

                <h3 style={{ fontSize: "17px", marginTop: "15px", marginBottom: "8px" }}>
                  Apa perbedaan antara AdSense dan AdMob?
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>Google AdSense</strong> dikhususkan untuk situs web di desktop dan ponsel, sementara <strong>Google AdMob</strong> dikhususkan untuk aplikasi ponsel (iOS dan Android). Keduanya dari Google dan menggunakan jaringan pengiklan yang sama.
                </p>

                <div className="alert alert-success mt-3" style={{ lineHeight: "1.8" }}>
                  <strong>✓ Kesimpulan:</strong> Gunakan Kalkulator AdSense di atas untuk membuat proyeksi realistis, lalu fokus pada peningkatan lalu lintas dan peningkatan kualitas konten untuk mencapai keuntungan setinggi mungkin dari program Google AdSense.
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default GoogleAdsenseCalculator;